import {
  computed,
  ref
} from "vue";
import {
  defineStore
} from "pinia";

import {
  getLeaderboard
} from "@/api/leaderboardApi.js";


export const LEADERBOARD_TYPES =
  Object.freeze({
    COUNTRY_SCORE:
      "country_score",

    SYSTEM_PROGRESS:
      "system_progress"
  });


function normalizeRows(
  items,
  type
) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.map(
    (item, index) => {
      const base = {
        rank:
          Number(
            item?.rank
          )
          || index + 1,

        countryCode:
          String(
            item?.country_code
            ?? item?.countryCode
            ?? ""
          )
            .trim()
            .toLowerCase(),

        flagUrl:
          String(
            item?.flag_url
            ?? item?.flagUrl
            ?? ""
          )
            .trim()
      };

      if (
        type
        === LEADERBOARD_TYPES
          .SYSTEM_PROGRESS
      ) {
        return {
          ...base,

          clearedLevels:
            Math.max(
              0,
              Number(
                item?.cleared_levels
                ?? item?.clearedLevels
                ?? 0
              )
              || 0
            )
        };
      }

      return {
        ...base,

        score:
          Math.max(
            0,
            Number(
              item?.score
              ?? 0
            )
            || 0
          )
      };
    }
  );
}


export const useLeaderboardStore =
  defineStore(
    "leaderboard",
    () => {
      const activeType =
        ref(
          LEADERBOARD_TYPES
            .COUNTRY_SCORE
        );

      const rowsByType =
        ref({
          [
            LEADERBOARD_TYPES
              .COUNTRY_SCORE
          ]: [],

          [
            LEADERBOARD_TYPES
              .SYSTEM_PROGRESS
          ]: []
        });

      const loading =
        ref(false);

      const error =
        ref(null);

      const rows =
        computed(
          () =>
            rowsByType.value[
              activeType.value
            ]
            ?? []
        );

      function switchType(
        type
      ) {
        if (
          !Object.values(
            LEADERBOARD_TYPES
          ).includes(type)
        ) {
          return false;
        }

        activeType.value =
          type;

        return true;
      }

      async function load(
        type =
          activeType.value
      ) {
        if (
          !switchType(type)
        ) {
          return [];
        }

        loading.value =
          true;

        error.value =
          null;

        try {
          const result =
            await getLeaderboard({
              type
            });

          rowsByType.value[
            type
          ] =
            normalizeRows(
              result?.items,
              type
            );

          return rowsByType.value[
            type
          ];
        } catch (err) {
          error.value =
            err;

          throw err;
        } finally {
          loading.value =
            false;
        }
      }

      return {
        activeType,
        rows,
        loading,
        error,
        switchType,
        load
      };
    }
  );
